module.exports = __webpack_public_path__ + "img/2551dc992385970623f2e7530c84803f.png";